import React from "react"
import Img from "gatsby-image"
import { css } from "@emotion/core"

import ImageCorner from "../../content/assets/imagecorner.svg"

export default function PrettyImage({ fluid, ...props }) {
  return (
    <div
      css={css`
        position: relative;
        width: 100%;
        height: 100%;
      `}
    >
      <Img
        css={css`
          border-radius: 25px;
          width: 100%;
          height: 100%;
          background: var(--color-darker-primary)
        `}
        fluid={fluid}
        {...props}
      />
      <ImageCorner
        css={css`
          stroke: var(--color-gradient-secondary);
          stroke-width: 2px;
          stroke-linecap: round;
          position: absolute;
          bottom: -10px;
          right: -10px;
        `}
      />
    </div>
  )
}

// TODO: Support media query
